function insertAfter(newElement: HTMLElement, referenceElement: HTMLElement): void {
    const parentNode = referenceElement.parentNode;

    if (parentNode) {
        parentNode.insertBefore(newElement, referenceElement.nextSibling);
    } else {
        throw Error('referenceElement.parentNode is null');
    }
}

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        insertAfter(element: HTMLElement): HTMLElement;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.insertAfter = function (element: HTMLElement): HTMLElement {
    insertAfter(this, element);

    return this;
};

// ----------------------------------------------------------------------------

export default insertAfter;
